import { render, staticRenderFns } from "./Blade2a.vue?vue&type=template&id=65a63300"
import script from "./Blade2a.vue?vue&type=script&lang=js"
export * from "./Blade2a.vue?vue&type=script&lang=js"
import style0 from "./Blade2a.vue?vue&type=style&index=0&id=65a63300&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports